import React, { useState, useEffect } from "react";
import { Gamepad2 } from "lucide-react";
import "./gaming-loader.css";
import Navbar from "./navbar";
import Footer from "./footer";

interface GamingLoaderProps {
  message?: string;
}

const GamingLoader: React.FC<GamingLoaderProps> = ({
  message = "Loading...",
}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 95) return 95;
        return prev + Math.random() * 15;
      });
    }, 200);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Navbar />
      <div className="gaming-loader-container">
        <div className="gaming-loader-content">
          <Gamepad2 className="gaming-loader-icon" />
          <h2 className="gaming-loader-title">{message}</h2>
          <div className="gaming-progress-bar">
            <div
              className="gaming-progress-fill"
              style={{ width: `${progress}%` }}
            >
              <div className="gaming-progress-glow"></div>
            </div>
          </div>
          <p className="gaming-loader-percentage">{Math.floor(progress)}%</p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default GamingLoader;
